import { Component, Input, OnInit } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { GalaxyInputModule, SelectInputOptionInterface } from '@vendasta/galaxy/input';
import { of } from 'rxjs';
import { DynamicOptionsComponent } from '../dynamic-options';
import { CommonModule } from '@angular/common';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'automata-days-input',
  templateUrl: './days-input.component.html',
  styleUrls: ['./days-input.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    GalaxyInputModule,
  ],
})
export class DaysInputComponent implements OnInit, DynamicOptionsComponent {
  daysFormControl: UntypedFormControl = new UntypedFormControl('', [Validators.min(1), Validators.max(30)]);
  daysOptions: SelectInputOptionInterface[];

  selectedValue$ = of(null);

  @Input() initialValue: number;

  constructor(private readonly translateService: TranslateService) {}

  ngOnInit(): void {
    if (this.initialValue) {
      this.daysFormControl.setValue(this.initialValue);
    }
    const options: SelectInputOptionInterface[] = [
      {
        label: this.translateService.instant('AUTOMATIONS.EDITOR.FILTERS.USER_DATA.DATA_LABELS.X_DAY', { days: 1 }),
        value: 1,
      },
    ].concat(
      Array(29)
        .fill(null)
        .map((_, days) => {
          return {
            label: this.translateService.instant('AUTOMATIONS.EDITOR.FILTERS.USER_DATA.DATA_LABELS.X_DAYS', {
              days: days + 2,
            }),
            value: days + 2,
          };
        }),
    );
    this.daysOptions = options;
    this.daysOptions.map((o) => {
      if (o.value === this.daysFormControl.value) {
        o.selected = true;
      }
      return o;
    });
  }

  getSelectedValue(): number {
    return this.daysFormControl.value;
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [this.daysFormControl];
  }

  isFormValid(): boolean {
    return this.daysFormControl.valid;
  }
}
